import React, { useState, useEffect } from "react";
import { useNavigate, createSearchParams, useLocation } from "react-router-dom";
import styled from "@emotion/styled";

import { TEXT_DROPDOWN } from "../../../utils/text";
import { toSlug, searchParamsObj } from "../../../utils/dataHandler";
import { ROUTES } from "../../../utils/consts";
import { GovType, MapType } from "../../../types/dataTypes";
// import { handleClickGov } from "../../../utils/mapDataHandler";
import { LAYER_IDS } from "../../../utils/mapConsts";
import { MapGeoJSONFeature } from "maplibre-gl";
import { handleClickGov } from "../../../utils/mapDataHandler";

type ListOfGovsProps = {
  map: MapType;
  setViewDropdown: Function;
  selectedGov: string;
  setSelectedGov: Function;
  gov_adm1: GovType;
};

function ListOfGovs({ map, setViewDropdown, selectedGov, setSelectedGov, gov_adm1 }: ListOfGovsProps) {
  const [highlightedGov, setHighlightedGov] = useState<string>("");
  const [govNames, setGovNames] = useState<string[]>([]);

  useEffect(() => {
    if (map.current) {  
      // Extract the names from the features and filter out duplicates
      const names = gov_adm1.features?.map((feature: MapGeoJSONFeature) => feature.properties?.ADM1_EN);
      setGovNames(names);
    }
  }, [map]);
  

  const handleClickGovCallBack = (e: React.MouseEvent<HTMLElement>) => {
    // Fly to the selected gov
    const gov = e.currentTarget.textContent as string;
    handleClickGov(gov, map);

    // Close the dropdown
    setViewDropdown(false);

    // Set the selected gov
    setSelectedGov(gov);
  };

  return (
    <ListStyle>
      {govNames && govNames.map((gov: any, index) => {
        return (
          <SingleItemStyle
            key={index}
            highlight={highlightedGov === gov || selectedGov === gov}
            onMouseOver={() => setHighlightedGov(gov)}
            onClick={(e) => handleClickGovCallBack(e)}
          >
            {gov}
          </SingleItemStyle>
        );
      })}
    </ListStyle>
  );
}

export default ListOfGovs;

const ListStyle = styled.ul<{}>(
  () => `
    list-style-type: none;
    margin: 0;
    padding: 10px;
    max-height: 50vh;
    overflow: auto;
    position: absolute;
    top: 0;
    left: 0;
    width: 92%;
    background-color: white;
    z-index: 100; /* Ensure it has a higher z-index */
    border-radius: 5px;
  `
);

const SingleItemStyle = styled.li<{ highlight: boolean }>(
  ({ highlight }) => `
    font-weight: ${highlight ? "bold" : "normal"};
    margin: 10px;
    padding: 0;
    &:hover {
      cursor: pointer;
    }
  `
);